/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Brew_Tea_AmountInputs */

const vi_shop_brew_tea_amount = /** @type {(inputs: Shop_Brew_Tea_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lượng chè`)
};

/**

* @param {Shop_Brew_Tea_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_brew_tea_amount = /** @type {((inputs?: Shop_Brew_Tea_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Brew_Tea_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_brew_tea_amount(inputs)
});